import styled from "@emotion/styled/macro";

const Check = styled.button`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 10em;
    margin-top: 1.5em;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 2em 0 0;
    height: 2.375em;
    width: -webkit-fill-available;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 0.5em;
  text-align: center;
  font-weight: bold;
`;

const Wrapper = styled.div``;
const CheckButton = ({ children }) => {
  return (
    <Wrapper>
      <Check type="submit">{children}</Check>
    </Wrapper>
  );
};

export default CheckButton;
